import type { VFC } from 'react';
import { type TreeSelectProps as TreeSelectPropsAnt, TreeSelect as AntdTreeSelect } from 'antd';
import { removeAccents } from '@/utils/string/removeAccents';
import { Tag } from '@/components/tag/Tag';

const { TreeNode } = AntdTreeSelect;

export type TreeSelectProps = Pick<
  TreeSelectPropsAnt,
  | 'allowClear'
  | 'className'
  | 'defaultValue'
  | 'disabled'
  | 'id'
  | 'listHeight'
  | 'multiple'
  | 'onChange'
  | 'placeholder'
  | 'showCheckedStrategy'
  | 'value'
  | 'treeCheckable'
  | 'popupMatchSelectWidth'
  | 'filterTreeNode'
  | 'loading'
  | 'maxTagCount'
  | 'treeData'
  | 'treeDefaultExpandAll'
  | 'treeLine'
  | 'treeNodeFilterProp'
  | 'onDropdownVisibleChange'
  | 'open'
  | 'filterTreeNode'
  | 'showSearch'
  | 'style'
> & {
  'data-cy'?: string;
};

const tagRender: TreeSelectPropsAnt['tagRender'] = ({ label, value, ...props }) => {
  return <Tag {...props}>{label || value}</Tag>;
};

// We should add prop labelInAriaLive to this component when this issue is closed https://github.com/ant-design/ant-design/issues/35643
// Currently aria-label is not working and in tree select screen reader always read the value instead of label
export function TreeSelect(props: TreeSelectProps): ReturnType<VFC<TreeSelectProps>> {
  return (
    <AntdTreeSelect
      filterTreeNode={(input, option) => {
        const searched = removeAccents(input).toLowerCase().trim();

        if (typeof option?.label === 'string') return removeAccents(option.label).toLowerCase().includes(searched);
        return false;
      }}
      tagRender={tagRender}
      {...props}
    />
  );
}

TreeSelect.SHOW_ALL = AntdTreeSelect.SHOW_ALL;
TreeSelect.SHOW_PARENT = AntdTreeSelect.SHOW_PARENT;
TreeSelect.SHOW_CHILD = AntdTreeSelect.SHOW_CHILD;
TreeSelect.TreeNode = TreeNode;
